import React from "react";
import Grid from "@material-ui/core/Grid";
import ProductBlock from "../ProductBlock/ProductBlock";

const MerchandiseBlock = (props) => {
    const { block } = props;
    const columns = block.columns || 3;
    const products = (block.products_block && block.products_block.products) || [];
    const checkboxDisplay = block.products_block && block.products_block.checkboxDisplay;
    const colSize = Math.max(1, Math.floor(12 / columns));

    return (
        <div className="block merchandise-block" id={"merchandise-block-" + block.id}>
            {block.header && <div dangerouslySetInnerHTML={{ __html: block.header }} />}
            <Grid container spacing={2}>
                {products.map((p) => (
                    <Grid item xs={12} sm={colSize} key={p.id}>
                        <ProductBlock block={p} checkboxDisplay={checkboxDisplay} />
                    </Grid>
                ))}
            </Grid>
            {block.footer && <div dangerouslySetInnerHTML={{ __html: block.footer }} />}
        </div>
    );
};

export default MerchandiseBlock;
